module.exports = "/assets/data/43c2317749cfaefb7e43071dc68b32af-CF33.data.json";